<saksliste [saker]="saker()" (vedSorteringAktivert)="vedSorteringAktivert($event)"/>
@if(!nyeSakerSkjemaDeaktivert()){
  <nye-saker-skjema [moete]="moete()" (vedVisFulltSkjemaAktivert)="vedVisFulltNyeSakerSkjema($event)" (vedNyeSakerOpprettet)="vedNyeSakerOpprettet($event)" class="ikke-print" data-tips-id="ny-sak-skjema"/>
}
